import { render } from "./Manglares.vue?vue&type=template&id=22aa8848"
import script from "./Manglares.vue?vue&type=script&lang=js"
export * from "./Manglares.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__